const CODE_TYPE_COLORS = {
  0: '#D32F2F',
  1: '#FF9800',
  2: '#27AE60',
  3: '#666666',
  4: '#666666',
};

const getColorByCodeType = code => CODE_TYPE_COLORS[code?.code_type] ?? 'gray';

const formatToSelectOption = (value, text, other) => ({
  label: text,
  value,
  ...other,
});

const orderListByName = list => list.sort((a, b) => {
  const labelA = String(a?.label ?? '').trim();
  const labelB = String(b?.label ?? '').trim();

  return labelA.localeCompare(labelB, undefined, {
    sensitivity: 'base',
    numeric: true,
    ignorePunctuation: true,
  });
});

const formatBaseList = (list, key, extraOptions) => {
  if (!list || list.length === 0) return [];

  const formattedList = list.map(item => formatToSelectOption(
    item?.[key],
    item?.name,
    extraOptions ? extraOptions(item) : undefined,
  ));
  return orderListByName(formattedList);
};

export const formatSimpleList = (list, key = 'id') => formatBaseList(list, key);

export const formatCodeList = (list, key = 'id') => formatBaseList(list, key, item => ({
  dotColor: getColorByCodeType(item),
}));

export const validateField = (filter, value) => {
  if (!filter || filter.length === 0) return true;
  if (Array.isArray(filter)) {
    return filter.includes(value);
  }
  return filter === value;
};
